export default [
  [`Размеры`, `2XS`, `XS`, `S`, `M`, `L`, `XL`, `2XL`, `3XL`, `4XL`, `5XL`],
  [
    `Российский размер`,
    `40`,
    `42`,
    `44`,
    `46`,
    `48`,
    `50`,
    `52`,
    `54`,
    `56`,
    `58`
  ],
  [
    `Плечи`,
    `36`,
    `37`,
    `38`,
    `39`,
    `40`,
    `41,1`,
    `42,2`,
    `43,3`,
    `44,4`,
    `45,5`
  ],
  [
    `Грудь`,
    `40,5`,
    `42,5`,
    `44,5`,
    `46,5`,
    `48,5`,
    `50,5`,
    `52,5`,
    `54,5`,
    `56,5`,
    `58,5`
  ],
  [
    `Длина`,
    `57,5`,
    `59`,
    `60,5`,
    `62,5`,
    `62,5`,
    `64,5`,
    `64,5`,
    `64,5`,
    `66,5`,
    `68,5`
  ]
];
